import { render, staticRenderFns } from "./reduceCostHistory.vue?vue&type=template&id=af8a7176&scoped=true"
import script from "./reduceCostHistory.vue?vue&type=script&lang=js"
export * from "./reduceCostHistory.vue?vue&type=script&lang=js"
import style0 from "./reduceCostHistory.vue?vue&type=style&index=0&id=af8a7176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8a7176",
  null
  
)

export default component.exports